'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import Image from 'next/image';
import { request } from '@isoapp/common/platform/networking/client/request';
import { AccountDisconnect } from '#@/components/AccountDisconnect.tsx';
import { ConnectButton } from '#@/components/ConnectButton.tsx';
import { graphql } from '#@graphql';
export function AccountInfo() {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["account", "me"],
      async queryFn() {
        const result = await request.auth(AccountInfo_Query, {});
        return result.me;
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t0);
  if (isPending) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <s-section heading="Connected Account" accessibilityLabel="Loading account information"><s-spinner /></s-section>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (error || !data) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <s-section heading="Connected Account" accessibilityLabel="Account information"><ConnectButton /></s-section>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const connectedDate = data.shopifyConnection?.connectedDate;
  let t1;
  if ($[3] !== connectedDate) {
    t1 = typeof connectedDate === "string" ? Temporal.Instant.from(connectedDate).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    }) : "\u2014";
    $[3] = connectedDate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const connectionDate = t1;
  let t2;
  if ($[5] !== data.imageUrl || $[6] !== data.name || $[7] !== data.username) {
    t2 = <s-grid-item>{data.imageUrl ? <Image src={data.imageUrl} alt={data.name ?? data.username ?? "Profile"} width={48} height={48} className="size-12 rounded-full object-cover" /> : <div className="size-12 rounded-full bg-(--surface-secondary)" aria-hidden={true} />}</s-grid-item>;
    $[5] = data.imageUrl;
    $[6] = data.name;
    $[7] = data.username;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== data.name) {
    t3 = !!data.name && <s-heading>{data.name}</s-heading>;
    $[9] = data.name;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== data.username) {
    t4 = !!data.username && <s-text color="subdued">@{data.username}</s-text>;
    $[11] = data.username;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== data.email) {
    t5 = !!data.email && <s-text color="subdued">{data.email}</s-text>;
    $[13] = data.email;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <s-grid-item><s-stack gap="small">{t3}{t4}{t5}</s-stack></s-grid-item>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t2 || $[20] !== t6) {
    t7 = <s-grid gridTemplateColumns="auto 1fr" gap="base" alignItems="center">{t2}{t6}</s-grid>;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <s-divider />;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <s-text color="subdued">Connected Since</s-text>;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== connectionDate) {
    t10 = <s-grid gridTemplateColumns="1fr" gap="base"><s-grid-item><s-stack gap="small">{t9}<s-text>{connectionDate}</s-text></s-stack></s-grid-item></s-grid>;
    $[24] = connectionDate;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AccountDisconnect />;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t7) {
    t12 = <s-section heading="Connected Account" accessibilityLabel="District account information"><s-stack gap="base">{t7}{t8}{t10}{t11}</s-stack></s-section>;
    $[27] = t10;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
const AccountInfo_Query = graphql(`
  query AccountInfo {
    me {
      id
      name
      username
      email
      imageUrl
      shopifyConnection {
        connectedDate
      }
    }
  }
`);